<script lang="ts">
  import { fade } from 'svelte/transition';
  import KeyboardIcon from '$icons/KeyboardIcon.svelte';
  import { browser } from '$app/environment';

  export let open = false;

  // Detect if user is on Mac
  const isMac = browser && /Mac|iPhone|iPad|iPod/.test(navigator.userAgent);
  const modKey = isMac ? '⌘' : 'Ctrl';
  const altKey = isMac ? 'Option' : 'Alt';

  const hotkeys = [
    { keys: [modKey, 'F'], description: 'Toggle fullscreen' },
    { keys: [modKey, 'M'], description: 'Minimize editor' },
    { keys: [modKey, 'B'], description: 'Bold' },
    { keys: [modKey, 'I'], description: 'Italic' },
    { keys: [modKey, 'U'], description: 'Underline' },
    { keys: [altKey, '/'], description: 'Toggle cheatsheet' },
    { keys: ['Esc'], description: 'Exit fullscreen / Close editor' },
  ];
</script>

<button
  type="button"
  class="bg-gray-dark-4 hover:bg-gray-dark-5 text-gray-dark-12 hidden h-8 w-8 items-center justify-center rounded sm:flex"
  on:click={() => (open = !open)}
>
  <KeyboardIcon class="h-5 w-5" />
</button>

{#if open}
  <button
    type="button"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
    on:click|self={() => (open = false)}
    transition:fade={{ duration: 150 }}
  >
    <div
      class="bg-gray-dark-3 border-gray-dark-4 mx-4 w-full max-w-[400px] rounded-lg border p-6 shadow-xl"
      transition:fade={{ duration: 100, delay: 50 }}
    >
      <div class="mb-4 flex items-center justify-between">
        <h3 class="text-gray-dark-12 text-lg font-semibold">Keyboard Shortcuts</h3>
      </div>
      <div class="flex flex-col gap-y-3">
        {#each hotkeys as { keys, description }}
          <div class="flex items-center justify-between gap-x-4">
            <div class="flex min-w-[120px] items-center gap-x-1">
              {#each keys as key}
                <kbd class="bg-gray-dark-4 text-gray-dark-11 rounded px-2 py-1 text-sm">{key}</kbd>
              {/each}
            </div>
            <span class="text-gray-dark-11 flex-1 text-right text-sm">{description}</span>
          </div>
        {/each}
      </div>
    </div>
  </button>
{/if}
